import { infoCards } from '@/mocks/homeData';

const tagColorMap: Record<string, string> = {
  accent: 'bg-accent-500 text-white',
  primary: 'bg-primary-500 text-white',
  secondary: 'bg-secondary-500 text-white',
};

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新吃瓜速递
            </h2>
            <p className="mt-1 text-sm text-foreground-500">
              {`${new Date().getMonth() + 1}月${new Date().getDate()}日 · 实时更新中`}
            </p>
          </div>
          <a
            href="#ranking"
            className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看热榜
            <i className="ri-arrow-right-line text-sm"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {infoCards.slice(0, 6).map((card, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className={`absolute top-3 left-3 text-xs px-2 py-0.5 rounded-full font-medium ${tagColorMap[card.tagColor]}`}>
                  {card.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors duration-200">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {card.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {card.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-message-2-line"></i>
                    {card.comments.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {infoCards.length > 6 && (
          <div className="mt-8">
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer flex items-center gap-4">
              <div className="relative w-20 h-20 shrink-0 rounded-lg overflow-hidden">
                <img
                  src={infoCards[6].image}
                  alt={infoCards[6].title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${tagColorMap[infoCards[6].tagColor]}`}>
                    {infoCards[6].tag}
                  </span>
                </div>
                <h3 className="text-sm font-heading font-semibold text-foreground-900 line-clamp-1">
                  {infoCards[6].title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1">{infoCards[6].time} · {infoCards[6].views}阅读</p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 text-xl shrink-0"></i>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}